<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title title"><i class="fa fa-code-branch"></i> {{ "TITLE.PERMITTED-FLOWS" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="authorityForm">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox"
                       class="custom-control-input"
                       id="addRemoveAllCheckbox"
                       [checked]="wasAllSelected()"
                       (click)="addOrRemoveAll($event)">
                <label class="custom-control-label"
                       for="addRemoveAllCheckbox"><b>{{ "LABEL.ALL" | translate }}</b></label>
              </div>
              <div class="custom-control custom-checkbox my-1 mr-sm-2"
                   *ngFor="let workflow of workflows; let index=index">
                <input type="checkbox"
                       class="custom-control-input"
                       id="addPermisoCheckbox{{index}}"
                       name="workflowCheckbox"
                       [value]="workflow.id"
                       [checked]="wasSelected(workflow)"
                       (change)="addRemove($event, workflow)">
                <label class="custom-control-label"
                       for="addPermisoCheckbox{{index}}">
                  {{workflow.description }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="!areThereSelectedWorkflows"
            (click)="save()"><i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle" aria-hidden="true"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>


